import { type Tool } from '@ag-ui/core';

import { SUBSCRIBED_TOOLS } from './consts';
import { DETECT_TEXT_TOOL } from './detectText';
import { FILE_EDIT_COMPLETE_TOOL } from './fileEditComplete';
import { GENERATE_TEXT_TOOL } from './generateText';
import { SUBMIT_TRANSLATIONS_TOOL } from './submitTranslations';

/** All registered tools, passed to runAgent on every invocation. */
export const ALL_TOOLS: Tool[] = [
  FILE_EDIT_COMPLETE_TOOL,
  GENERATE_TEXT_TOOL,
  DETECT_TEXT_TOOL,
  SUBMIT_TRANSLATIONS_TOOL,
  ...SUBSCRIBED_TOOLS,
];

export { BaseToolResultSchema } from './baseResult';
// Re-export tool types
export { BRAND_KIT_SETUP_TOOL_NAME, type BrandKitSetupResult } from './brandKitSetup';
export {
  DETECT_TEXT_TOOL_NAME,
  type DetectTextRegion,
  type DetectTextResult,
} from './detectText';
export {
  ELICIT_MISSING_CONTEXT_TOOL_NAME,
  type ElicitMissingContextAction,
  type ElicitMissingContextCandidate,
  type ElicitMissingContextResult,
} from './elicitMissingContext';
export {
  FILE_EDIT_COMPLETE_TOOL_NAME,
  type FileEditCompleteArgs,
  type FileEditCompleteEdit,
  type FileEditCompleteImageEdit,
  type FileEditCompleteResult,
  type FileEditCompleteTextEdit,
  isImageEdit,
} from './fileEditComplete';
export {
  GENERATE_TEXT_TOOL_NAME,
  type GenerateTextArgs,
  type GenerateTextResult,
} from './generateText';
export {
  SUBMIT_TRANSLATIONS_TOOL_NAME,
  type SubmitTranslationsArgs,
  type SubmitTranslationsEntry,
  type SubmitTranslationsResult,
} from './submitTranslations';
// Re-export validation
export {
  findToolNameByCallId,
  isDetectTextResult,
  isElicitMissingContextResult,
  isFileEditCompleteResult,
  isGenerateTextResult,
  isSubmitTranslationsResult,
  parseToolContent,
  type ToolCallResultParams,
  type ToolResultValidationResult,
  type ValidatedToolCallResultParams,
  validateToolCallResult,
} from './validation';
